import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randBetweenDate } from "@ngneat/falso";

export const randBetweenDateNodeDef = createNodeDef({
  type: "randBetweenDate",
  displayName: "Between Date",
  defaultName: "date",
  fields: [
    { type: DataFieldType.DATE, key: "from", label: "From" },
    { type: DataFieldType.DATE, key: "to", label: "To" },
  ],
  initialData: () => ({
    from: new Date(),
    to: new Date(new Date().setDate(new Date().getDate() + 5)),
  }),
  generate: ({ node }) => {
    return randBetweenDate({ from: node.data.from, to: node.data.to });
  },
});
